var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3125 7.875C7.3125 7.56434 7.56434 7.3125 7.875 7.3125H12.375C12.6857 7.3125 12.9375 7.56434 12.9375 7.875C12.9375 8.18566 12.6857 8.4375 12.375 8.4375H7.875C7.56434 8.4375 7.3125 8.18566 7.3125 7.875Z",
    fill: "#4B5C71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3125 10.125C7.3125 9.81434 7.56434 9.5625 7.875 9.5625H12.375C12.6857 9.5625 12.9375 9.81434 12.9375 10.125C12.9375 10.4357 12.6857 10.6875 12.375 10.6875H7.875C7.56434 10.6875 7.3125 10.4357 7.3125 10.125Z",
    fill: "#4B5C71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 3.375C2.25 2.75368 2.75368 2.25 3.375 2.25H14.625C15.2463 2.25 15.75 2.75368 15.75 3.375V14.625C15.75 15.2463 15.2463 15.75 14.625 15.75H3.375C2.75368 15.75 2.25 15.2463 2.25 14.625V3.375ZM14.625 3.375H3.375V14.625H14.625V3.375Z",
    fill: "#4B5C71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 2.25C5.93566 2.25 6.1875 2.50184 6.1875 2.8125V15.1875C6.1875 15.4982 5.93566 15.75 5.625 15.75C5.31434 15.75 5.0625 15.4982 5.0625 15.1875V2.8125C5.0625 2.50184 5.31434 2.25 5.625 2.25Z",
    fill: "#4B5C71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/Notebook.866ac14e6541dba2d299581b99e9a506.svg";
export { ForwardRef as ReactComponent };